/**
 * next/image özel loader — CDN DIT URL'lerini ("{origin}/{W}x{H}/{Q}/{fit}/{path}")
 * istenen genişliğe göre yeniden yazar; en-boy oranı kaynak URL'den korunur.
 * DIT olmayan URL'ler (ytimg, s3, /storage vb.) olduğu gibi geçer.
 */
const DIT_RE = /^(https?:\/\/[^/]+)\/(\d+)x(\d+)\/(\d+)\/(cover|inside)\/(.+)$/i

const DEFAULT_QUALITY = 70

export default function cdnImageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}): string {
  const m = String(src || '').match(DIT_RE)
  if (!m) return src
  const [, origin, w0, h0, q0, fit, rest] = m
  const sourceW = Number(w0)
  const sourceH = Number(h0)
  if (!sourceW || !sourceH) return src
  const height = Math.max(1, Math.round((width * sourceH) / sourceW))
  // Preset kalitesi belirleyicidir: manşet q100, kart q60 kalır.
  // next/image'in varsayılan 75'i yüksek kaliteli manşeti düşürmesin.
  const sourceQuality = Math.max(1, Math.min(100, Number(q0) || DEFAULT_QUALITY))
  const requestedQuality = quality && quality !== 75 ? quality : sourceQuality
  const q = Math.max(1, Math.min(requestedQuality, sourceQuality))
  return `${origin}/${width}x${height}/${q}/${fit}/${rest}`
}
